var _polyline, _line, _polyline2, _line2, _line3, _line4, _line5, _path, _line6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorDining(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "4.259 21.73 5.024 28.841 10.222 28.841 10.907 34.433"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 2.976,
    y1: 34.433,
    x2: 5.024,
    y2: 28.841
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "37.741 21.73 36.976 28.841 31.778 28.841 31.093 34.433"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 39.024,
    y1: 34.433,
    x2: 36.976,
    y2: 28.841
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 21.016,
    y1: 34.01,
    x2: 21.016,
    y2: 23.801
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 30.707,
    y1: 23.801,
    x2: 11.324,
    y2: 23.801
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 25.331,
    y1: 34.039,
    x2: 16.7,
    y2: 34.039
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21,11.827c-2.528,0-4.577,2.049-4.577,4.577h9.155c0-2.528-2.049-4.577-4.577-4.577Z"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 11.827,
    x2: 21,
    y2: 7.567
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorDining);
export default __webpack_public_path__ + "static/media/indoor-dining.1f3ad7bc1f85cb6e75319f026d9e974b.svg";
export { ForwardRef as ReactComponent };